<template>
  <div class="subscribe_box d-none d-md-block">
    <div class="card">
      <img class="card-img-top" v-if="youtubeBanner.imageUrl" :src="youtubeBanner.imageUrl" alt="youtube_banner">
      <div class="card-img-overlay">
        <div class="row">
          <div class="col-md-8 col-9">
            <!-- <h4 class="card-title">GM Nanashi </h4>
            <p class="card-text">Nanashi</p>
            <a class="btn btn_primary btn_subscribe">
              <i class="fab fa-youtube"></i> Subscribe
            </a> -->
          </div>
          <div class="col-md-4 col-3 text-right mt-auto">
            <!-- <img src="@/assets/images/play_btn.svg" alt="play_btn.svg"> -->
            <div class="play-icon big">
              <i class="fa fa-play" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <a href="https://www.youtube.com/channel/UCk0175IjuulfbwXyD-lOh2A" target="_blank" class="stretched-link"></a>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'YoutubeBanner',
  props: ['type'],
  data () {
    return {
      youtubeBanner: []
    }
  },
  mounted () {
    this.fetchLatestYoutubeBanner()
  },
  methods: {
    fetchLatestYoutubeBanner () {
      this.$store
        .dispatch('fetchLatestYoutubeBanner', { type: this.type })
        .then((resp) => {
          this.youtubeBanner = resp.data.youtube_banner
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
  .interview_section .interview_card h4.card-title {
    /* width: 60%; */
    margin: 0px auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/YoutubeBanner.vue